// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__Uoi4Y","cell":"ColumnAccessor_cell__38tvW","firstCellAccent":"ColumnAccessor_firstCellAccent__k-_C9"};